import React, { useEffect } from 'react';
import documentHtml from './lectureTrackerDocument';

export default function LectureTrackerPage() {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = 'Lectures';
    return () => { document.title = originalTitle; };
  }, []);

  // An unsandboxed same-origin document keeps the existing tracker isolated
  // from portfolio themes, while retaining the portfolio's localStorage origin.
  return (
    <iframe
      title="Lecture tracker"
      srcDoc={documentHtml}
      style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', border: 0, background: '#f7f7f3', zIndex: 2147483647 }}
    />
  );
}
